import React, { ReactNode, useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { getAuth } from '../APIHelp'; // Correct path based on your structure
import { isAuth } from '../IsAuth'; // Correct path based on your structure

interface ProtectedRouteProps {
  children: ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  return isAuth() ? <>{children}</> : <Navigate to="/login" />;
}
